import React, { useRef, useState } from 'react';
import { arrayOf, object, shape, string } from 'prop-types';
import { BgLayer } from '../bg-layer.jsx';
import styles from './container.module.css';
import scopeLogger from 'lib/scope-logger.js';

const console = scopeLogger(
  'RMI:promo:container',
  process.env.NODE_ENV === 'development',
);

Container.propTypes = {
  desc: shape({
    id: string,
    widgets: arrayOf(object),
    backgrounds: arrayOf(object),
  }),
};
export default function Container(props) {
  const {
    desc: { id, children, backgrounds },
  } = props;
  /**
   *
   * @type {React.MutableRefObject<HTMLDivElement>}
   */
  const ref = useRef();
  // const [ displayClass, setDisplayClass ] = useState(styles.invisible);
  const [displayClass, setDisplayClass] = useState('');
  /*

  const checkCoverage = useCallback(() => {
    getElementIntersection(ref.current, {
      root: ref.current.closest('article')
    })
      .then((intersectionEntry) => {
        if (!ref.current) {
          return;
        }
        let {
          intersectionRect: rect,
          rootBounds,
        } = intersectionEntry;
        if (rootBounds === null) {
          console.warn('incomplete intersection entry', intersectionEntry);
          rootBounds = {
            width: window.innerWidth,
            height: window.innerHeight,
          };
        }
        const coverage = (rect.width * rect.height) / (rootBounds.width * rootBounds.height);
        const event = new CustomEvent('container-coverage', {
          bubbles: true,
          detail: {
            coverage
          }
        });
        ref.current.dispatchEvent(event);
        setDisplayClass('');
      });
  }, []);

  useEffect(() => {
    checkCoverage();
  }, [ checkCoverage ]);
*/

  /*
  useDebouncedEventListener('resize', checkCoverage, window, {
    passive: true,
    timeout: 200
  });
*/

  return (
    <div
      id={id}
      ref={ref}
      className={`${styles.containerWidget} ${displayClass}`}
    >
      {backgrounds.map((background) => {
        return <BgLayer key={background.id} desc={background} />;
      })}

      {children.map((widget) => {
        return <widget.type key={widget.id} desc={widget} />;
      })}
    </div>
  );
}
